import { render, staticRenderFns } from "./IndividualCourse.vue?vue&type=template&id=042fd658&scoped=true"
import script from "./IndividualCourse.vue?vue&type=script&lang=ts"
export * from "./IndividualCourse.vue?vue&type=script&lang=ts"
import style0 from "./IndividualCourse.vue?vue&type=style&index=0&id=042fd658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042fd658",
  null
  
)

export default component.exports